module.exports = __webpack_public_path__ + "img/mb_Logo.6c34b040.svg";